import { Button, Grid } from "@material-ui/core";
import { useDevice } from "components/DeviceContext.js";
import CardPauta from "./CardPauta";
import CardProgramacao from "./CardProgramacao";
import imgMegafone from 'Imagens/img-negafone.png'
import observacao from 'data/observacao.json'

const CardPautaProgramacao = () => {
    const { isMobile, isLaptop } = useDevice();
    return (
        <>
            <Grid container style={{
                position: 'relative',
                justifyContent: 'center',
                minHeight: '90vh',
                marginTop: isMobile ? '' : '-1em',
                marginBottom: '5em',
                backgroundColor: 'fff'
            }}>
                <img src={imgMegafone} alt='' style={{
                    position: 'absolute',
                    left: '0',
                    top: '300px',
                    zIndex: '9999',
                    transform: "scaleX(-1)",
                    width: '250px',
                    display: isMobile ? 'none' : 'flex'
                }} />

                <Grid item xs={12} sm={6} md={12} style={{
                    justifyContent: 'center',
                    display: 'flex',
                    marginTop: isMobile ? '1em' : '-2em'
                }}>
                    <img style={{ width: isMobile ? '100%' : '70%', height: isMobile ? '100%' : '80%' }} src='https://www.cnm.org.br/storage/noticias/2023/Imagens/Institucional/estaduaisAtualizadas.png' alt='' />
                </Grid>

                <Grid  id="programacao" item sx={12} md={3} xl={2} style={{ padding: isMobile ? '1em' : '0' }}>
                    <CardPauta />
                </Grid>

                <Grid item sx={12} md={3} xl={2} style={{ padding: isMobile ? '1em' : '0' }}>
                    <CardProgramacao />
                </Grid>

                <img src={imgMegafone} alt='' style={{
                    position: 'absolute',
                    right: '0',
                    bottom: isLaptop ? '100px' : '50px',
                    zIndex: '9999',
                    width: '250px',
                    display: isMobile ? 'none' : 'flex'
                }} />


                <Grid
                    item
                    md={12}
                    style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontSize: isMobile ? '15px' : '20px',
                        padding: isMobile ? '1em' : '0',
                        marginTop: '2em'
                    }}
                >
                    {observacao.observacao && (
                        <p style={{ color: 'var(--vermelho)' }}>
                            {observacao.observacao}
                            {/* Atenção: entrada no Plenário é limitada e somente será permitida para aqueles que fizerem inscrição prévia */}
                        </p>
                    )}

                    {observacao.link && observacao.nomeBotao && (
                        <a href={observacao.link} target="_blank" rel="noopener noreferrer">
                            <Button
                                style={{
                                    backgroundColor: 'var(--amarelo)',
                                    color: '#0055a5',
                                    fontWeight: 'bold',
                                    fontSize: '20px',
                                    borderRadius: '25px',
                                    padding: '10px 20px',
                                    textTransform: 'none',
                                    '&:hover': {
                                        backgroundColor: '#FFA000',
                                    },
                                }}
                            >
                                {observacao.nomeBotao}
                            </Button>
                        </a>
                    )}
                </Grid>


            </Grid>
        </>
    )
}

export default CardPautaProgramacao
